/**
 * Chatbot enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Chatbot status labels
export const chatbotStatusLabels = {
    draft: 'Draft',
    active: 'Active',
    paused: 'Paused',
    archived: 'Archived',
};
export const chatbotStatusValues = Object.keys(chatbotStatusLabels);
// Chatbot node type labels
export const chatbotNodeTypeLabels = {
    start: 'Start',
    send_message: 'Send Message',
    quick_reply: 'Quick Reply',
    condition: 'Condition',
    delay: 'Delay',
    collect_info: 'Collect Info',
    book_appointment: 'Book Appointment',
    handoff: 'Handoff',
};
export const chatbotNodeTypeValues = Object.keys(chatbotNodeTypeLabels);
// Conversation status labels
export const conversationStatusLabels = {
    active: 'Active',
    bot_handling: 'Bot Handling',
    agent_handling: 'Agent Handling',
    closed: 'Closed',
    expired: 'Expired',
};
export const conversationStatusValues = Object.keys(conversationStatusLabels);
// Message role labels
export const messageRoleLabels = {
    bot: 'Bot',
    user: 'User',
    agent: 'Agent',
    system: 'System',
};
export const messageRoleValues = Object.keys(messageRoleLabels);
// Message type labels
export const messageTypeLabels = {
    text: 'Text',
    image: 'Image',
    quick_reply: 'Quick Reply',
    template: 'Template',
    attachment: 'Attachment',
};
export const messageTypeValues = Object.keys(messageTypeLabels);
// Messaging platform labels
export const messagingPlatformLabels = {
    facebook_messenger: 'Facebook Messenger',
    instagram_dm: 'Instagram DM',
    whatsapp: 'WhatsApp',
    sms: 'SMS',
    // A phone call answered by the voice receptionist. Its transcript lives in
    // the thread like any other message; nothing is ever SENT on it.
    phone: 'Phone',
};
export const messagingPlatformValues = Object.keys(messagingPlatformLabels);
// The transport that actually carried an SMS-platform message. LoopMessage
// and Osis pick iMessage, then RCS, then SMS per message and report which;
// Esendex and Twilio only ever send SMS and report nothing.
export const messageTransportLabels = {
    imessage: 'iMessage',
    rcs: 'RCS',
    sms: 'SMS',
};
export const messageTransportValues = Object.keys(messageTransportLabels);
// Why a staff SMS reply was refused for good. Sending the same reply again
// can't go through, so the inbox says why instead of asking staff to retry.
// Read as "Not sent: <label>".
export const smsRefusalLabels = {
    held_elsewhere: 'this number is in an SMS conversation with another clinic',
    no_shared_sender: "SMS can't be sent to numbers in this country yet",
    too_long: 'too long for SMS, shorten it and send again',
};
// Why Esendex failed an SMS it had accepted, when no retry will ever fix it.
// The inbox reads "Delivery failed · <label>" instead of asking staff to
// retry; the key is also the `reason` on the PostHog failure event.
export const smsPermanentFailureLabels = {
    landline: 'this number is a landline',
    opted_out: 'this number has opted out of texts',
    invalid_number: "this isn't a valid mobile number",
};
// Esendex status names, lowercase and letters only: receipts spell them with
// or without spaces and in either case ("Landline Not Allowed", "OptedOut").
const smsPermanentFailureStatuses = new Map([
    ['landlinenotallowed', 'landline'],
    ['optedout', 'opted_out'],
    ['msisdninvalid', 'invalid_number'],
]);
/** The permanent failure a delivery receipt's reason names, if it is one. */
export function smsPermanentFailure(reason) {
    const status = reason.toLowerCase().replaceAll(/[^a-z]/g, '');
    return smsPermanentFailureStatuses.get(status) ?? null;
}
// Chatbot version change type labels
export const chatbotVersionChangeTypeLabels = {
    created: 'Created',
    updated: 'Updated',
    published: 'Published',
    restored: 'Restored',
};
export const chatbotVersionChangeTypeValues = Object.keys(chatbotVersionChangeTypeLabels);
// Tone region labels
export const toneRegionLabels = {
    ie: 'Ireland',
    uk: 'United Kingdom',
    us: 'United States',
};
export const toneRegionValues = Object.keys(toneRegionLabels);
// Conversation stage labels
export const conversationStageLabels = {
    first_contact: 'First Contact',
    qualified: 'Qualified',
    booking: 'Booking',
    follow_up: 'Follow Up',
    escalation: 'Escalation',
    enquiry: 'Enquiry',
    interest: 'Interest',
    stall: 'Stall',
};
export const conversationStageValues = Object.keys(conversationStageLabels);
// Chatbot goal labels
export const chatbotGoalLabels = {
    free_consultation: 'Free Consultation',
    paid_consultation: 'Paid Consultation',
    direct_booking: 'Direct Booking',
    phone_callback: 'Phone Callback',
};
export const chatbotGoalValues = Object.keys(chatbotGoalLabels);
// Chatbot tone labels
export const chatbotToneLabels = {
    friendly: 'Friendly',
    professional: 'Professional',
    luxe: 'Luxe',
};
export const chatbotToneValues = Object.keys(chatbotToneLabels);
//# sourceMappingURL=chatbot.js.map